<script>
import draggable from 'vuedraggable'
import {
    isNumberStr,
    dateTimeFormat,
    dateTypeOptions,
    dateRangeTypeOptions,
    defaultActiveData
} from '@/utils/rightBoard'
import RulesDialog from './RulesDialog.vue'
import DateDaysDialog from './DateDaysDialog.vue'
import ComputeDialog from './ComputeDialog.vue'
import { transOperator } from '@/utils/tools'
export default {
    name: 'right',
    props: {
        form: {
            type: Object,
            default: () => {}
        },
        selectItem: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        RulesDialog,
        DateDaysDialog,
        ComputeDialog
    },
    data() {
        return {
            currentTab: 'field',
            iconsVisible: false,
            currentIconModel: null,
            upLoadDialogVisible: false,
            activeData: defaultActiveData,
            rulesDialogVisible: false,
            areaList: [],
            dictTypeList: [],
            viewList: [],
            eventCodeList: [], //任务表单-选择业务
            relTaskList: [], //任务表单-关联任务字段
            showComputeDialog: false,
        }
    },
    watch: {
        selectItem: {
            handler(value) {
                if(value) this.activeData = value
            },
            immediate: true,
            deep: true
        }
    },
    render(h) {
        const { activeData } = this
        const { api } = this.$attrs.option
        // 回显相关
        const eventCodeSelected = eventCode => {
            if (!eventCode) return
            // 获取关联任务字段
            const { api } = this.$attrs.option
            if (api.getShowFormItemsByEventCode) {
                api.getShowFormItemsByEventCode({ eventCode }).then((res) => {
                    const { data } = res
                    this.relTaskList = data
                })
            }
        }
        const getEventCodeList = () => {
            if(api.getEventListByPage) {
                api.getEventListByPage({pageNum: 1, pageSize: 99, category: "NORMAL", status: 2}).then(res => {
                    const { data: { list } } = res
                    if (!list && !Array.isArray(list)) return;
                    this.eventCodeList = list
                })
            }
        }
        if(activeData.typeId === 'ByDictSelect') {
            // 字典下拉框
            if(api.getAllDictType) {
                api.getAllDictType().then((res) => {
                    this.dictTypeList = res.data
                })
            }
        }
        if(activeData.typeId === 'TREE_RELATION') {
            if (this.viewList.length) return
            const { eventCode } = this.$attrs
            activeData.eventCode = eventCode
            activeData.idField = "id"
            // 获取视图
            if(eventCode && api.getEventViewPage) {
                api.getEventViewPage({ eventCode, pageNum: 1, pageSize: 99 }).then(res => {
                    const { data: { list } } = res
                    this.viewList = list
                })
            }
        }
        if(activeData.typeId === 'BIZ_RELATION') {
            if(this.eventCodeList.length) return
            getEventCodeList()
            const { eventCode } = this.$attrs
            eventCode && eventCodeSelected(eventCode)
        }
        if(activeData.typeId === 'TASK_FORM') {
            // 任务表单中下拉框回显
            const { eventCode } = this.$attrs
            if (this.viewList.length && this.relTaskList.length) return
            eventCode && eventCodeSelected(eventCode)
            if(this.eventCodeList.length) return
            getEventCodeList()
        }
        // 一些方法
        const setDefaultValue = val => {
            if (Array.isArray(val)) {
                if (val.every((e) => typeof e === "string")) {
                    return val.join(",")
                } else {
                    if (this.activeData.__config__.label === "部门") {
                        return val.map((e) => e.deptName).join(",")
                    } else {
                        return JSON.stringify(val)
                    }
                }
            }
            if (typeof val === "boolean") {
                return `${val}`
            }
            return val
        }
        const onDefaultValueInput = str => {
            if (Array.isArray(this.activeData.__config__.defaultValue)) {
                // 数组
                this.$set(
                    this.activeData.__config__,
                    "defaultValue",
                    str.split(",").map((val) => (isNumberStr(val) ? +val : val))
                )
            } else if (["true", "false"].indexOf(str) > -1) {
                // 布尔
                this.$set(this.activeData.__config__, "defaultValue", JSON.parse(str))
            } else {
                // 字符串和数字
                this.$set(
                    this.activeData.__config__,
                    "defaultValue",
                    isNumberStr(str) ? +str : str
                )
            }
        }
        // icon对话框
        const openIconsDialog = () => {} // 之后迁移
        // 时间
        const setTimeValue = (val, type) => {
            const valueFormat = type === "week" ? dateTimeFormat.date : val
            this.$set(this.activeData.__config__, "defaultValue", null)
            this.$set(this.activeData, "value-format", valueFormat)
            this.$set(this.activeData, "format", val)
        }
        const dateOptions = () => {
            if (
                this.activeData &&
                this.activeData.type !== undefined &&
                this.activeData.__config__.tag === "el-date-picker"
            ) {
                if (this.activeData["start-placeholder"] === undefined) {
                    return dateTypeOptions
                }
                return dateRangeTypeOptions
            }
            return []
        }
        // 下拉选择
        const addSelectItem = () => {
            const _opts = this.activeData.__slot__ ? this.activeData.__slot__.options : this.activeData.options
            _opts.push({ label: "", value: ""})
        }
        const handleSave = () => {} // 之后迁移
        const handleSliderChange = (val) => {
            const [start, end] = val
            const level = [start / 25, end / 25]
            this.activeData.level = level
            const {option: { api: { getDictOptionTree } }} = this.$attrs
            getDictOptionTree && getDictOptionTree({ maxLevel: start / 25 }).then((res) => {
                this.areaList = res.data || []
            })
        }
        const formItemList = this.form.design.formItems
            .filter(item => ["INPUT", "SELECT", "SELECT_V2", "TEXTAREA", "OrgTreeSelect", "org-user-picker"].includes(item.typeId))
            .map((obj) => {
                return {
                    code: obj.__vModel__,
                    name: obj.__config__.label,
                }
            })
        const allFormItem = this.form.design.formItems.filter(item => item.typeId !== 'INPUT_COMPUTED').map((obj) => {
            return {
                code: obj.__vModel__,
                name: obj.__config__.label,
            }
        })
        const taskNameList = this.form.design.formItems.filter(item => !["INFO_FEEDBACK", "TASK_FORM"].includes(item.typeId))
        const setCalculationRules = calculationRules => {
            this.$set(this.activeData, 'calculationRules', calculationRules)
        }
        const computedText = (arr) => {
            let str = '' 
            arr.map(item => {
                str = str + ` ${item.label} ${item.operator ? transOperator(item.operator) : ''}`
            })
            return str
        }
        const __vModel__ = (
            <el-form-item label="组件ID">
                <el-input v-model={ activeData.__vModel__ }></el-input>
            </el-form-item>
        )
        const componentName = (
            <el-form-item label="组件ID">{ activeData.__config__.componentName }</el-form-item>
        )
        const label = (
            <el-form-item label="标题">
                <el-input v-model={activeData.__config__.label} placeholder="请输入标题"></el-input>
            </el-form-item>
        )
        const placeholder = (
            <el-form-item label="占位提示">
                <el-input v-model={activeData.placeholder} placeholder="请输入占位提示" />
            </el-form-item>
        )
        const startPlaceholder = (
            <el-form-item label="开始占位">
                <el-input v-model={ activeData['start-placeholder'] } placeholder="请输入占位提示" />
            </el-form-item>
        ) 
        const endPlaceholder = (
            <el-form-item label="结束占位">
                <el-input v-model={ activeData['end-placeholder'] } placeholder="请输入占位提示" />
            </el-form-item>
        )
        const span = (
            <el-form-item label="表单栅格">
                <el-slider v-model={ activeData.__config__.span }  marks={{12: ''}} max={24} min={8} />
            </el-form-item>
        )
        const defaultValue = (
            <el-form-item label="默认值">
                <el-input 
                    value={setDefaultValue(activeData.__config__.defaultValue)}
                    placeholder="请输入默认值"
                    onInput={str => onDefaultValueInput(str)}
                />
            </el-form-item>
        )
        const checkboxMin = (
            <el-form-item label="至少应选">
                <el-input-number min={0} v-model={activeData.min} />
            </el-form-item>
        )
        const checkboxMax = (
            <el-form-item label="最多可选">
                <el-input-number min={0} v-model={activeData.max} />
            </el-form-item>
        )
        const slotPrepend =  activeData.__slot__?.prepend ? (
            <el-form-item label="前缀">
                <el-input v-model={activeData.__slot__.prepend} placeholder="请输入前缀" />
            </el-form-item>
        ) : null
        
        const slotAppend = activeData.__slot__?.append ? (
            <el-form-item label="后缀">
                <el-input v-model={activeData.__slot__.append} placeholder="请输入后缀" />
            </el-form-item>
        ) : null
        const prefixIcon = (
            <el-form-item label="前图标">
                <el-input v-model={activeData['prefix-icon']} placeholder="请输入前图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('prefix-icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const suffixIcon = (
            <el-form-item label="后图标">
                <el-input v-model={activeData['suffix-icon']} placeholder="请输入后图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('suffix-icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const icon = (
            <el-form-item label="按钮图标">
                <el-input v-model={activeData.icon} placeholder="请输入按钮图标名称">
                    <el-button slot="append" icon="el-icon-thumb" onClick={() => openIconsDialog('icon')}>选择</el-button>
                </el-input>
            </el-form-item>
        )
        const minRows = activeData.autosize?.minRows ? (
            <el-form-item label="最小行数">
                <el-input-number v-model={activeData.autosize.minRows} min={1} placeholder="最小行数" />
            </el-form-item>
        ) : null
        const maxRows = activeData.autosize?.maxRows ? (
            <el-form-item label="最大行数">
                <el-input-number v-model={activeData.autosize.maxRows} min={1} placeholder="最大行数" />
            </el-form-item>
        ) : null
        const min = (
            <el-form-item label="最小值"><el-input-number v-model={activeData.min} placeholder="最小值" /></el-form-item>
        )
        const max = (
            <el-form-item label="最大值"><el-input-number v-model={activeData.max} placeholder="最大值" /></el-form-item>
        )
        const step = (
            <el-form-item label="步长">
                <el-input-number v-model={activeData.step} placeholder="步数" />
            </el-form-item>
        )
        const precision = (
            <el-form-item label="精度">
                <el-input-number v-model={activeData.precision} min={0} placeholder="精度" />
            </el-form-item>
        )
        const controlsPosition = (
            <el-form-item label="按钮位置">
                <el-radio-group v-model={activeData['controls-position']}>
                    <el-radio-button label=""> 默认</el-radio-button>
                    <el-radio-button label="right"> 右侧</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const maxlength = (
            <el-form-item label="最多输入">
                <el-input v-model={activeData.maxlength} placeholder="请输入字符长度" scopedSlots={{append: () => '个字符'}} />
            </el-form-item>
        )
        const dateType = (
            <el-form-item label="时间类型">
                <el-select
                    v-model={activeData.type}
                    style="width: 100%"
                    placeholder="请选择时间类型"
                    onChange={val => setTimeValue(dateTimeFormat[val], val)}
                >
                {
                    dateOptions().map((item, index) => {
                        return (
                            <el-option key={index} label={item.label} value={item.value} />
                        )
                    })
                }
                </el-select>
            </el-form-item>
        )
        const fileSize = (
            <el-form-item label="文件大小">
                <el-input v-model={activeData.__config__.fileSize} placeholder="请输入文件大小">
                    <el-select slot="append" v-model={activeData.__config__.sizeUnit} style="width: '66px'">
                        <el-option label="KB" value="KB" />
                        <el-option label="MB" value="MB" />
                        <el-option label="GB" value="GB" />
                    </el-select>
                </el-input>
            </el-form-item>
        )
        const listType = (
            <el-form-item label="列表类型">
                <el-radio-group v-model={activeData['list-type']} size="small">
                    <el-radio-button label="text"> text</el-radio-button>
                    <el-radio-button label="picture"> picture</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const buttonText = (
            <el-form-item label="按钮文字">
                <el-input v-model={activeData.__config__.buttonText} placeholder="请输入按钮文字" />
            </el-form-item>
        )
        const rangeSeparator = (
            <el-form-item label="分隔符">
                <el-input v-model={ activeData['range-separator'] } placeholder="请输入分隔符" />
            </el-form-item>
        )
        const format = (
            <el-form-item label="时间格式">
                <el-input value={activeData.format} placeholder="请输入时间格式" onInput={value => setTimeValue(value)} />
            </el-form-item>
        )
        // SELECT_V2
        const options = (
            <Fragment>
                <el-divider>选项</el-divider>
                <draggable animation={340} list={activeData.options} group="selectItem" handle=".option-drag">
                    {
                        activeData.options?.map((item, index) => {
                            return (
                                <div key={index} class="select-item">
                                    <div class="select-line-icon option-drag"><i class="el-icon-s-operation" /></div>
                                    <el-input v-model={item.label} placeholder="选项名" onInput={value => item.value = value} size="small" />
                                    <div class="close-btn select-line-icon" onClick={() => activeData.options.splice(index, 1)}>
                                        <i class="el-icon-remove-outline" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </draggable>
                <div style="margin-left: 20px; margin-bottom: 20px">
                    <el-button onClick={() => addSelectItem()} icon="el-icon-circle-plus-outline" type="text" style="padding-bottom: 0">添加选项</el-button>
                    <el-button onClick={() => handleSave()} type="text" style="padding-bottom: 0">下载模版</el-button>
                    <el-tooltip effect="dark" content="导入数据需严格按照模版规范" placement="right">
                        <el-button onClick={() => this.upLoadDialogVisible = true } type="text" style="padding-bottom: 0">导入数据</el-button>
                    </el-tooltip>
                </div>
            </Fragment>
        )
        // CHECKBOX
        const slotOptions = (
            <Fragment>
                <el-divider>选项</el-divider>
                <draggable animation={340} list={activeData.__slot__?.options} group="selectItem" handle=".option-drag">
                    {
                        activeData.__slot__?.options?.map((item, index) => {
                            return (
                                <div key={index} class="select-item">
                                    <div class="select-line-icon option-drag"><i class="el-icon-s-operation" /></div>
                                    <el-input v-model={item.label} placeholder="选项名" onInput={value => item.value = value} size="small" />
                                    <div class="close-btn select-line-icon" onClick={() => activeData.__slot__.options.splice(index, 1)}>
                                        <i class="el-icon-remove-outline" />
                                    </div>
                                </div>
                            )
                        })
                    }
                </draggable>
                <div style="margin-left: 20px; margin-bottom: 20px">
                    <el-button onClick={() => addSelectItem()} icon="el-icon-circle-plus-outline" type="text" style="padding-bottom: 0">添加选项</el-button>
                    <el-button onClick={() => handleSave()} type="text" style="padding-bottom: 0">下载模版</el-button>
                    <el-tooltip effect="dark" content="导入数据需严格按照模版规范" placement="right">
                        <el-button onClick={() => this.upLoadDialogVisible = true } type="text" style="padding-bottom: 0">导入数据</el-button>
                    </el-tooltip>
                </div>
            </Fragment>
        )
        const optionType = (
            <el-form-item label="选项样式">
                <el-radio-group v-model={activeData.__config__.optionType}>
                    <el-radio-button label="default">默认</el-radio-button>
                    <el-radio-button label="button">按钮</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const showLabel = (
            <el-form-item label="显示标签">
                <el-switch v-model={activeData.__config__.showLabel} />
            </el-form-item>
        )
        const range = (
            <el-form-item label="范围选择">
                <el-switch v-model={activeData.range} 
                    onChange={value => {
                        this.activeData.__config__.defaultValue = value ? [this.activeData.min, this.activeData.max] : this.activeData.min
                    }} 
                />
            </el-form-item>
        )
        const showWordLimit = (
            <el-form-item label="输入统计">
                <el-switch v-model={activeData['show-word-limit']} />
            </el-form-item>
        )
        const checkStrictly = (
            <el-form-item label="数据层级">
                <el-radio-group v-model={activeData.checkStrictly}>
                    <el-radio label={1}>全部</el-radio>
                    <el-radio label={0}>仅末级</el-radio>
                </el-radio-group>
                <div class="block">
                    <el-slider
                        onChange={value => handleSliderChange(value)}
                        range
                        min={25}
                        max={150}
                        show-tooltip={false}
                        value={[25, 75]}
                        step={25}
                        marks={{
                            25: "省份",
                            50: "地市",
                            75: "区县",
                            100: "镇街",
                            125: "村社",
                            150: {
                                style: {
                                    width: "30px",
                                },
                                label: "网格",
                            }
                        }}
                    />
                </div>
            </el-form-item>
        )
        const rangeArr = (
            <el-form-item label="数据范围">
                <el-cascader
                    v-model={activeData.rangeArr}
                    placeholder="请选择"
                    options={this.areaList}
                    clearable={true}
                    props={{
                        checkStrictly: true,
                        label: 'name',
                        value: 'code',
                        children: 'child',
                        multiple: true,
                    }}
                    show-all-levels={false}
              />
            </el-form-item>
        )
        const multiple = (
            <el-form-item label="是否多选">
                <el-switch v-model={activeData.multiple} />
            </el-form-item>
        )
        const showAllLevels = (
            <el-form-item label="展示全路径">
                <el-switch v-model={activeData['show-all-levels']} />
            </el-form-item>
        )
        const filterable = (
            <el-form-item label="可否筛选">
                <el-switch v-model={activeData.filterable} />
            </el-form-item>
        )
        const clearable = (
            <el-form-item label="能否清空">
                <el-switch v-model={activeData.clearable} />
            </el-form-item>
        )
        const showTip = (
            <el-form-item label="显示提示">
                <el-switch v-model={activeData.__config__.showTip} />
            </el-form-item>
        )
        const limit = (
            <el-form-item label="文件个数">
                <el-input-number v-model={activeData.limit} />
            </el-form-item>
        )
        const required = (
            <el-form-item label="是否必填">
                <el-switch v-model={activeData.__config__.required} />
            </el-form-item>
        )
        const mobileCopy = (
            <el-form-item label="移动端复制">
                <el-switch v-model={activeData.copy} />
            </el-form-item>
        )
        const isUnique = (
            <el-form-item label="是否唯一键">
                <el-switch v-model={activeData.__config__.isUnique} />
            </el-form-item>
        )
        const stepStrictly = (
            <el-form-item label="严格步数">
                <el-switch v-model={activeData['step-strictly']} />
            </el-form-item>
        )
        const textAlign = (
            <el-form-item label="对齐方式">
                <el-radio-group v-model={activeData.textAlign}>
                    <el-radio-button label="left"> 左对齐</el-radio-button>
                    <el-radio-button label="center"> 居中</el-radio-button>
                    <el-radio-button label="right"> 右对齐</el-radio-button>
                </el-radio-group>
            </el-form-item>
        )
        const encryptWord = activeData.props?.word ? (
            <el-form-item label="脱敏位数">
                <el-input v-model={activeData.props.word} placeholder="请输入" />
            </el-form-item>
        ) : null
        const encryptRule = activeData.props?.rule ? (
            <el-form-item label="脱敏方式">
                <el-radio-group v-model={activeData.props.rule} size="mini">
                    <el-radio-button label="front">前</el-radio-button>
                    <el-radio-button label="center">中</el-radio-button>
                    <el-radio-button label="after">后</el-radio-button>
                </el-radio-group>
            </el-form-item>
        ) : null
        const maxSelect = (
            <el-form-item label="最多可选数">
                <el-input-number step-strictly={true} min={1} v-model={activeData.max} /> 
            </el-form-item>
        )
        const dictType = (
            <el-form-item label="字典类型">
                <el-select placeholder="请选择字典类型" v-model={activeData.dictType}>
                    {
                        this.dictTypeList.map(item => <el-option key={item.id} value={item.dictType} label={item.dictName} />)
                    }
                </el-select>
            </el-form-item>
        )
        const activeText = (
            <el-form-item label="开启提示">
                <el-input v-model={activeData['active-text']} placeholder="请输入开启提示" />
            </el-form-item>
        )
        const inactiveText = (
            <el-form-item label="关闭提示">
                <el-input v-model={activeData['inactive-text']} placeholder="请输入关闭提示" />
            </el-form-item>
        )
        const showStops = (
            <el-form-item label="显示间断点">
                <el-switch v-model={activeData['show-stops']} />
            </el-form-item>
        )
        const pickerOptions = activeData['picker-options']?.selectableRange ? (
            <el-form-item label="时间段">
                <el-input v-model={activeData['picker-options'].selectableRange} placeholder="请输入时间段" />
            </el-form-item>
        ) : null
        const allowHalf = (
            <el-form-item label="允许半选">
                <el-switch v-model={activeData['allow-half']} />
            </el-form-item>
        )
        const showText = (
            <el-form-item label="辅助文字">
                <el-switch v-model={activeData['show-text']} />
            </el-form-item>
        )
        const showScore = (
            <el-form-item label="显示分数">
                <el-switch v-model={activeData['show-score']} />
            </el-form-item>
        )
        const calculate = (
            <el-form-item label="计算规则">
                <DateDaysDialog
                    checks={activeData.checks}
                    onChecks={data => this.$set(activeData, 'checks', data)}
                    workingDate={activeData.workingDate}
                    onWorkingDate={data => this.$set(activeData, 'workingDate', data)}
                    has-work-time={activeData.hasWorkTime}
                    onHasWorkTime={data => this.$set(activeData, 'hasWorkTime', data)}
                    attrs={this.$attrs}
                />
            </el-form-item>
        )
        const unit = (
            <el-form-item label="单位">
                <el-select placeholder="请选择字典类型" v-model={activeData.unit}>
                    <el-option value="day" label="天" />
                    <el-option value="hour" label="小时" />
                </el-select>
            </el-form-item>
        )
        const viewCode = (
            <el-form-item label="视图">
                <el-select v-model={activeData.viewCode} style="{ width: '100%' }" placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const nameField = (type) => {
            let children = null
            if(type === 'father') {
                children = formItemList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            } else if (type === 'relation') {
                children = this.relTaskList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            }
            return  (
                <el-form-item label="主字段">
                    <el-select v-model={activeData.nameField} placeholder="请选择主字段">
                        { children }
                    </el-select>
                </el-form-item>
            )
        }
        const descField = (type) => {
            let children = null
            if(type === 'father') {
                children = formItemList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            } else if (type === 'relation') {
                children = this.relTaskList.map((item, index) => {
                    return <el-option key={index} label={item.name} value={item.code} />
                })
            }
            return (
                <el-form-item label="副字段">
                    <el-select v-model={activeData.descField} placeholder="请选择副字段" multiple>
                        { children }
                    </el-select>
                </el-form-item>
            )
        }
        const eventCode = (
            <el-form-item label="选择业务">
                <el-select v-model={activeData.eventCode} placeholder="请选择业务" onChange={eventCode => eventCodeSelected(eventCode)}>
                    {
                        this.eventCodeList.map((item, index) => {
                            return <el-option key={index} label={item.eventName} value={item.eventCode} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const idField = (
            <el-form-item label="ID字段">
                <el-select v-model={activeData.idField} placeholder="请选择Id字段">
                    {
                        this.relTaskList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskFormMore = (
            <el-form-item label="是否允许填写多份" label-width="130px">
                <el-switch v-model={activeData.more} />
            </el-form-item>
        )
        const startViewCode = (
            <el-form-item label="发起视图">
                <el-select v-model={activeData.startViewCode} placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const writeViewCode = (
            <el-form-item label="填报视图">
                <el-select v-model={activeData.writeViewCode} placeholder="请选择视图">
                    {
                        this.viewList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskCode = (
            <el-form-item label="关联任务字段" label-width="100px">
                <el-select v-model={activeData.taskCode} placeholder="请选择任务字段">
                    {
                        this.relTaskList.map((item, index) => {
                            return <el-option key={index} label={item.name} value={item.code} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const taskName = (
            <el-form-item label="关联任务名称" label-width="100px">
                <el-select v-model={activeData.taskName} placeholder="请选择任务名称">
                    {
                        taskNameList.map((item, index) => {
                            return <el-option key={index} label={item.__config__.label} value={item.__vModel__} />
                        })
                    }
                </el-select>
            </el-form-item>
        )
        const previewBtnName = (
            <el-form-item label="查看按钮名称" label-width="100px">
                <el-input v-model={activeData.previewBtnName} placeholder="请输入去查看按钮名称" />
            </el-form-item>
        )
        const fillBtnName = (
            <el-form-item label="填报按钮名称" label-width="100px">
                <el-input v-model={activeData.fillBtnName} placeholder="请输入去填报按钮名称" />
            </el-form-item>
        )
        const computedDialog = (
            <el-form-item label="计算表达式">
                <el-button type="text" onClick={() => this.showComputeDialog = true}>配置</el-button>
            </el-form-item>
        )
        const computedLabel = activeData.calculationRules?.operator ? (
            <el-form-item label="计算方式">
                <span style="color: red">{computedText(activeData.calculationRules.operator)}</span>
            </el-form-item>
        ) : null
        const componentRender = {
            // 辅助型组件
            INPUT: [__vModel__, label, placeholder, span, defaultValue, slotPrepend, slotAppend, prefixIcon, suffixIcon, maxlength, showLabel, showWordLimit, clearable, required, mobileCopy, isUnique ],
            SELECT_V2: [ __vModel__, label, placeholder, span, defaultValue, options ],
            TEXTAREA: [__vModel__, label, placeholder, span, defaultValue, minRows, maxRows, maxlength, showLabel, showWordLimit, clearable, required, mobileCopy, isUnique],
            PASSWORD: [__vModel__, label, placeholder, span, defaultValue, slotPrepend, slotAppend, maxlength, showLabel, clearable, required, mobileCopy, isUnique],
            NUMBER_INPUT: [__vModel__, label, placeholder, span, defaultValue, min, max, step, precision, controlsPosition, showLabel, stepStrictly, required, isUnique],
            TINYMCE: [__vModel__, label, placeholder, span, defaultValue, showLabel, required, isUnique],
            DESC_TEXT: [__vModel__, label, placeholder, span, defaultValue, textAlign, isUnique],
            DIVIDER: [__vModel__, span],
            SIGN_PAD: [__vModel__, label, span, required],
            Duration: [__vModel__, label, placeholder, span, required, isUnique ],
            ENCRYPTINPUT: [__vModel__, label, placeholder, span, required, isUnique, encryptWord, encryptRule],
            // 进阶型组件
            OrgTreeSelect: [__vModel__, label, placeholder, span, showLabel, clearable, multiple, required, isUnique],
            "org-user-picker": [__vModel__, label, placeholder, span, showLabel, multiple, required, isUnique, maxSelect], 
            ByDictSelect: [__vModel__, label, placeholder, span, showLabel, multiple, required, isUnique, dictType],
            RADIO: [__vModel__, label, placeholder, span, slotOptions, optionType, showLabel, required, isUnique],
            CHECKBOX: [__vModel__, label, placeholder, span, slotOptions, optionType, showLabel, required, isUnique],
            SWITCH: [__vModel__, label, placeholder, span, activeText, inactiveText, showLabel, required, isUnique],
            SLIDER: [__vModel__, label, placeholder, span, min, max, step, showLabel, showStops, range, required, isUnique],
            TIME: [__vModel__, label, placeholder, span, pickerOptions, format, showLabel, clearable, required, isUnique],
            TIME_RANGE: [__vModel__, label, startPlaceholder, endPlaceholder, span, rangeSeparator, format, showLabel, clearable, required, isUnique],
            DATE: [__vModel__, label, placeholder, span, dateType, format, showLabel, clearable, required, isUnique],
            DATE_RANGE: [__vModel__, label, startPlaceholder, endPlaceholder, span, dateType, rangeSeparator, format, showLabel, clearable, required, isUnique],
            RATE: [__vModel__, label, startPlaceholder, endPlaceholder, span, defaultValue, max, showLabel, allowHalf, showText, showScore, required, isUnique],
            UPLOAD: [__vModel__, label, span, fileSize, listType, buttonText, showLabel, showTip, multiple, limit, required, isUnique],
            DATE_CALCULATE: [__vModel__, label, placeholder, span, showLabel, required, isUnique, calculate, unit],
            // 系统组件
            ID: [label, span, isUnique],
            CREATE_BY: [label, span, isUnique],
            CREATE_TIME: [label, span, isUnique],
            UPDATE_BY: [label, span, isUnique],
            UPDATE_TIME: [label, span, isUnique],
            DEPT_CODE: [label, span, isUnique],
            // 扩展型组件
            PROVINCE_CITY: [__vModel__, label, placeholder, span, showLabel, required, isUnique],
            INPUT_MAP: [__vModel__, label, placeholder, span, showLabel, required, isUnique],
            AREA_CODE: [__vModel__, label, placeholder, span, showLabel, checkStrictly, rangeArr, multiple, showAllLevels, filterable, required, isUnique],
            // 业务型组件
            TREE_RELATION: [span, required, isUnique, viewCode, nameField('father'), descField('father')],
            BIZ_RELATION: [__vModel__, label, placeholder, span, showLabel, clearable, multiple, required, isUnique, eventCode, viewCode, idField, nameField('relation'), descField('relation')],
            TASK_FORM: [label, span, isUnique, taskFormMore, eventCode, startViewCode, writeViewCode, taskCode, taskName, previewBtnName, fillBtnName],
            INPUT_COMPUTED: [__vModel__, label, placeholder, span, defaultValue, showLabel, clearable, required, isUnique, computedLabel, computedDialog]
            // CARD: [__vModel__, label, placeholder, span]
        }
        const typeId = this.activeData.typeId
        const children = componentRender[typeId]

        //显隐回调
        const setRules = rules => {
            this.$emit('setRules', rules)
        }
        return (
            <div class="right-board">
                <el-tabs v-model={this.currentTab} class="center-tabs">
                    <el-tab-pane label="组件属性" name="field">
                        <el-scrollbar class="right-scrollbar">
                            {
                                h('el-form', { props: { labelWidth: '90px', size: 'small' } }, children)
                            }
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane label="表单属性" name="form">
                        <el-form label-width="90px" size="small" style="padding: 10px 0">
                            <el-form-item label="显隐规则">
                                <el-button plain onClick={ () => this.rulesDialogVisible = true }>{this.form.rules?.length ? '已设置' : '设置'}</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                {/* 显隐规则 */}
                <RulesDialog v-model={this.rulesDialogVisible} onSetRules={rules => setRules(rules)} formRules={this.form.rules} formItems={this.form.design.formItems} />
                {/* 计算组件弹框 */}
                <ComputeDialog 
                    v-model={this.showComputeDialog}
                    operator={activeData.calculationRules? 
                        JSON.parse( JSON.stringify(activeData.calculationRules.operator) ) : [{ label: '', value: '', operator: '', next: ''}]
                    } 
                    onConfirm={calculationRules => setCalculationRules(calculationRules)} 
                    allFormItem={allFormItem}
                />
            </div>
        )
    }
}
</script>
<style lang="scss" scoped>
.right-board {
  width: 340px;
  height: 100%;
  padding-top: 3px;
  background-color: #fff;

  .field-box {
    position: relative;
    height: calc(100% - 42px);
    box-sizing: border-box;
    overflow-y: auto;
  }
}

.select-item {
  display: flex;
  border: 1px dashed #fff;
  box-sizing: border-box;
  align-items: center;

  & .close-btn {
    cursor: pointer;
    color: #f56c6c;
  }

  & .el-input + .el-input {
    margin-left: 4px;
  }
}

.select-item + .select-item {
  margin-top: 4px;
}

.select-item.sortable-chosen {
  border: 1px dashed #409eff;
}

.select-line-icon {
  line-height: 32px;
  font-size: 22px;
  padding: 0 4px;
  color: #777;
}

.option-drag {
  cursor: move;
}

.time-range {
  .el-date-editor {
    width: 227px;
  }

  ::v-deep .el-icon-time {
    display: none;
  }
}

.node-label {
  font-size: 14px;
}

.node-icon {
  color: #bebfc3;
}

/* Set the width to 100% */
.width-full {
  width: 100% !important;
}

.flex-row {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
}

::v-deep .custom-tree-node span:first-child {
  display: inline-block;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>